import {addSignedMedia} from '../../state/ducks/media';
import {dispatch} from '../../state/store';
import arrayUtils from '../../utils/arrayUtils';
import mediaService from '../mediaService';
import iccMarketService from './iccMarketService';

const getProductsAssets = async (mediaNames) => {
    const assetsFromState = mediaService.getSignedMediaList();
    const mediaNamesList = Array.isArray(mediaNames) ? arrayUtils.unique(mediaNames) : [mediaNames];
    const mediaNamesToSign = mediaNamesList.filter(
        (mediaName) => !assetsFromState.some((asset) => asset.mediaId === mediaName && !asset.isExpired())
    );

    if (mediaNamesToSign.length) {
        const productAssets = await iccMarketService.getMediaUrl({mediaNameList: mediaNamesToSign});

        if (productAssets) {
            dispatch(addSignedMedia(productAssets));
        }

        return productAssets;
    } else {
        return [];
    }
};

export default {
    getProductsAssets,
};
